import React from 'react';
import { FileText, Star, CheckSquare, Clock, ArrowRight } from 'lucide-react';
export function NewUserDocumentHubSection() {
  // Recommended templates for new users
  const recommendedTemplates = [{
    id: 1,
    title: 'Employment Contract'
  }, {
    id: 2,
    title: 'Non-Disclosure Agreement'
  }, {
    id: 3,
    title: 'Service Agreement'
  }, {
    id: 4,
    title: 'Business Partnership Agreement'
  }, {
    id: 5,
    title: 'Lease Agreement'
  }];
  // Featured starter templates
  const featuredTemplates = [{
    id: 1,
    title: 'General Contract'
  }, {
    id: 2,
    title: 'Invoice Template'
  }, {
    id: 3,
    title: 'Terms of Service'
  }];
  const handleViewTemplate = (id: number) => {
    console.log(`Viewing template ${id}`);
    // This would open the specific template
  };
  const handleBrowseAllTemplates = () => {
    console.log('Browsing all templates');
    // This would navigate to the templates page
  };
  const handleRequestReview = () => {
    console.log('Requesting document review');
    // This would open the document review form
  };
  return <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-297">
      {/* Get Started with Templates - 50% width (2/4 columns) */}
      <div className="col-span-1 lg:col-span-2 border border-gray-200 p-5 rounded-lg" data-id="element-298">
        <div className="flex items-center mb-4" data-id="element-299">
          <FileText className="w-5 h-5 text-blue-600 mr-2" data-id="element-300" />
          <h3 className="text-lg font-semibold" data-id="element-301">Get Started with Templates</h3>
        </div>
        <p className="text-sm text-gray-500 mb-4" data-id="element-302">
          Start your journey by creating your first legal document from our most
          popular templates.
        </p>
        <div className="space-y-3" data-id="element-303">
          {recommendedTemplates.map(template => <div key={template.id} className="flex justify-between items-center py-2 border-b border-gray-100 group" data-id="element-304">
              <a href="#" onClick={e => {
            e.preventDefault();
            handleViewTemplate(template.id);
          }} className="flex items-center text-gray-700 group-hover:text-blue-600 font-medium cursor-pointer transition-colors" data-id="element-305">
                <FileText className="w-4 h-4 mr-2 text-gray-400 group-hover:text-blue-500" data-id="element-306" />
                {template.title}
              </a>
              <ArrowRight className="w-4 h-4 text-gray-300 group-hover:text-blue-500 opacity-0 group-hover:opacity-100 transition-all" data-id="element-307" />
            </div>)}
        </div>
        <button onClick={handleBrowseAllTemplates} className="mt-4 text-sm text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-md flex items-center justify-center w-full transition-colors cursor-pointer" data-id="element-308">
          Browse All Templates
        </button>
      </div>

      {/* Featured Templates - 25% width (1/4 column) */}
      <div className="col-span-1 border border-gray-200 p-5 rounded-lg" data-id="element-309">
        <div className="flex items-center mb-4" data-id="element-310">
          <Star className="w-5 h-5 text-amber-500 mr-2" data-id="element-311" />
          <h3 className="text-lg font-semibold" data-id="element-312">Featured Templates</h3>
        </div>
        <p className="text-sm text-gray-500 mb-4" data-id="element-313">
          Essential documents for every business.
        </p>
        <div className="space-y-3" data-id="element-314">
          {featuredTemplates.map(template => <div key={template.id} className="flex items-center py-2 border-b border-gray-100" data-id="element-315">
              <FileText className="w-4 h-4 text-gray-500 mr-2" data-id="element-316" />
              <a href="#" onClick={e => {
            e.preventDefault();
            handleViewTemplate(template.id);
          }} className="text-gray-700 hover:text-blue-600 hover:underline cursor-pointer" data-id="element-317">
                {template.title}
              </a>
            </div>)}
        </div>
        <button onClick={handleBrowseAllTemplates} className="mt-4 px-4 py-2 bg-amber-50 text-amber-600 rounded-md text-sm w-full hover:bg-amber-100 transition-colors cursor-pointer" data-id="element-318">
          View Template Library
        </button>
      </div>

      {/* Document Review - 25% width (1/4 column) */}
      <div className="col-span-1 border border-gray-200 p-5 rounded-lg" data-id="element-319">
        <div className="flex items-center mb-4" data-id="element-320">
          <CheckSquare className="w-5 h-5 text-green-600 mr-2" data-id="element-321" />
          <h3 className="text-lg font-semibold" data-id="element-322">Document Review</h3>
        </div>
        <p className="text-sm text-gray-600 mb-4" data-id="element-323">
          Get your documents reviewed by our legal experts for accuracy and
          compliance.
        </p>
        <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-324">
          <Clock className="w-4 h-4 mr-2" data-id="element-325" />
          <span data-id="element-326">48-hour turnaround time</span>
        </div>
        <button onClick={handleRequestReview} className="px-4 py-2 bg-green-50 text-green-600 rounded-md text-sm w-full hover:bg-green-100 transition-colors cursor-pointer" data-id="element-327">
          Request Review
        </button>
      </div>
    </div>;
}